import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../assets/Carte_Confituur_mobile_social_media_instagram.png'
import _imports_2 from '../assets/Carte_Confituur_mobile_social_media_facebook.png'


const _withScopeId = n => (_pushScopeId("data-v-079f1c8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { id: "menu" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "home", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "werk", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Carte Confituur"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "over", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "contact", -1))
const _hoisted_9 = { class: "hamburger" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Carte Confituur"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { id: "menuToggle" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "actualHamburger" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_17 = { id: "hamburgermenu" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "HOME", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "WERK", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "OVER", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "CONTACT", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hamburgerBelow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "workTogether" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("strong", null, "ZIN OM SAMEN TE WERKEN?")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "link" }, [
      /*#__PURE__*/_createElementVNode("a", { href: "mailto:hallo@carteconfituur.be" }, "hallo@carteconfituur.be")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "link" }, [
      /*#__PURE__*/_createElementVNode("a", { href: "tel:+32479262462" }, "0479 26 24 62")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "socials" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("strong", null, "VOLG ONZE SOCIALS")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "links" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.instagram.com/carteconfituur.be/",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_1,
          alt: "instagram"
        })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.facebook.com/carteconfituur",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "facebook",
          src: _imports_2,
          alt: "facebook"
        })
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        id: "homeLink"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/projects",
        id: "projectLink"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createElementVNode("li", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goHome()))
      }, _hoisted_6),
      _createVNode(_component_router_link, {
        to: "/info",
        class: "infoLink"
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/contact",
        class: "contactLink"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("li", {
        class: "logo",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goHome()))
      }, _hoisted_11),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checked) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.checked]
        ]),
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("ul", _hoisted_17, [
          _createVNode(_component_router_link, {
            to: "/",
            id: "homeLink"
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/projects",
            id: "projectLink"
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/info",
            class: "infoLink"
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "contactLink"
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _hoisted_22
        ])
      ])
    ])
  ]))
}